import classNames from "classnames";
import React from "react";
import { AppointmentType } from "src/services/availability";
import { flatSurcharge, money, percentageSurcharge, subtractSurchargeFromFee } from "src/utils/renderMoney";

type Props = {
    appointmentType: AppointmentType;
    className?: string;
}

export function AfterHoursPricingDetails({ appointmentType, className }: Props) {
    const total = Number(appointmentType.prePaymentFees) + Number(appointmentType.postBillingFees);

    const consultationFee = subtractSurchargeFromFee(total);
    const cardSurcharge = total - consultationFee;

    return <div className={classNames(className, "")}>
        <p>{appointmentType.appointmentName}</p>
        <ul className="mt-4 space-y-2.5 text-gray-700 font-base">
            <li className="flex">
                Consultation fee
                <span className="ml-auto font-semibold">${money(consultationFee)}</span>
            </li>
            <li className="flex flex-wrap">
                Card surcharge <span className="ml-auto">${money(cardSurcharge)}</span>
                <span className="text-xs text-gray-500 block w-full">A surcharge of {percentageSurcharge * 100}% plus ${flatSurcharge} applies for card payments.</span>
            </li>
            <li className="text-gray-800 text-lg flex flex-wrap">Total
                <span className="ml-auto font-semibold">${money(total)}</span></li>
        </ul>
    </div>
}